import { useEffect } from 'react'
import { type IResponseIntegrationListSyncFinished } from 'entities/Integrations'
import { WebsocketEvent } from 'entities/WebSocket'
import { useEntitiesContext } from 'entities/EntitiesExport'

type IHandlerEvent = (data: IResponseIntegrationListSyncFinished) => void

export const useEventIntegrationListSyncFinished = (handler: IHandlerEvent) => {
  const { websocket } = useEntitiesContext()

  useEffect(() => websocket.on(WebsocketEvent.IntegrationListSyncFinished, handler), [])
}
